import React from 'react';
import { groupBy } from 'lodash';
import t from 'utils/translationHelper';

import { PaymentPurposeDto } from '@alpha/payments-dtos';
import { TextField } from '@alpha/ui-lib/ui/external';
import { AutocompleteSelect, IAutocompleteSelectOption } from '@alpha/ui-lib/ui/Select';

import RenderValue from './RenderValue/RenderValue';
import { useStyles } from './PaymentPurposeDropdown.styles';

export type PurposeOption = IAutocompleteSelectOption & {
  group: string;
  type: string;
}

interface IProps {
  data: PaymentPurposeDto[];
  selectValue?: string;
  placeholderText?: string;
  testId?: string;
  handleChange?: (event: any, value: PurposeOption) => void;
  handleBlur?: (event: any) => void;
}
const PaymentPurposeDropdown: React.FC<IProps> = (props: IProps) => {
  const {
    data,
    selectValue,
    placeholderText,
    testId,
    handleChange,
    handleBlur,
  } = props;
  const styles = useStyles();

  let dataGroupedByGroup = groupBy(
    data,
    (dt: PaymentPurposeDto) => dt.group ?? 'Others',
  );

  dataGroupedByGroup = Object.keys(dataGroupedByGroup).sort().reduce(
    (obj, key) => {
      obj[key] = dataGroupedByGroup[key];
      return obj;
    },
    {},
  );

  const renderedPlaceHolderText = placeholderText || t('select_payment_purpose');

  const dropdownOptions = Object.keys(dataGroupedByGroup).map(
    (group: string) => {
      const dataRows = dataGroupedByGroup[group].map(
        (item) => ({
          label: item.description,
          value: item.code,
          img: '',
          group,
          type: item.type,
        }),
      );
      return dataRows;
    },
  ).flatMap((item) => item);

  return (
    <div className={styles.dropdownContainer}>
      <AutocompleteSelect
        onChange={(event, value) => handleChange?.(event, value as PurposeOption)}
        onBlur={handleBlur}
        placeholder={renderedPlaceHolderText}
        id={testId || 'dropdown'}
        renderOption={(item) => <RenderValue selectedPaymentPurpose={item} />}
        className={styles.dropdown}
        groupBy={(option) => (option as PurposeOption).group}
        options={dropdownOptions}
        value={selectValue ?? undefined}
        label=""
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              placeholder: renderedPlaceHolderText,
            }}
          />
        )}
        ListboxProps={{
          className: styles.listBox,
        }}
      />

    </div>
  );
};

export default PaymentPurposeDropdown;
